var _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMicOff(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#mic-off_svg__clip0_145_1413)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.418 4.518a2.667 2.667 0 014.249 2.149v3.56a.667.667 0 01-1.334 0v-3.56a1.334 1.334 0 00-2.64-.267.667.667 0 01-1.306-.266c.131-.648.499-1.224 1.031-1.616zm-.673 4.866a.667.667 0 01.726.145l3.414 3.413a.667.667 0 010 .943 2.667 2.667 0 01-4.552-1.884v-2c0-.27.163-.513.412-.617zm.922 2.226V12a1.334 1.334 0 001.677 1.287l-1.677-1.677zM7.333 10c.368 0 .667.299.667.667v1.331a3.954 3.954 0 00.666 2.225c.44.66 1.07 1.174 1.807 1.476a4.022 4.022 0 004.331-.84.667.667 0 11.932.954 5.341 5.341 0 01-3.07 1.479v2.042a.667.667 0 01-1.333 0v-2.042a5.328 5.328 0 01-3.776-2.329 5.288 5.288 0 01-.89-2.973v-1.323c0-.368.298-.667.666-.667zm9.333 0c.369 0 .667.299.667.667v1.326c0 .313-.028.625-.084.933a.667.667 0 11-1.312-.236c.042-.23.063-.464.063-.697L16.666 10zm0 0L16 11.992v-1.325c0-.368.298-.667.666-.667z",
    fill: "#231A1A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.667 4.667l14.666 14.667",
    stroke: "#D9754F",
    strokeWidth: 1.333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "mic-off_svg__clip0_145_1413"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(4 4)",
    d: "M0 0h16v16H0z"
  })))));
}

export default SvgMicOff;